/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminActivationRequestDto, AdminSystemLocaleDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminLocaleService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminLocaleService
   * @name UpdateLocale
   * @summary Update System Locale
   * @request PUT:/v1/admin/locales/{localeId}
   * @secure
   */
  updateLocale = (localeId: number, data: AdminSystemLocaleDto, params: RequestParams = {}) =>
    this.http.request<AdminSystemLocaleDto, any>({
      path: `/v1/admin/locales/${localeId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Delete a specific system locale by ID.
   *
   * @tags AdminLocaleService
   * @name DeleteLocale
   * @summary Delete System Locale
   * @request DELETE:/v1/admin/locales/{localeId}
   * @secure
   */
  deleteLocale = (localeId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/locales/${localeId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description Set a specific locale as the default locale.
   *
   * @tags AdminLocaleService
   * @name SetDefaultLocale
   * @summary Set Default Locale
   * @request PUT:/v1/admin/locales/{localeId}/default
   * @secure
   */
  setDefaultLocale = (localeId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/locales/${localeId}/default`,
      method: 'PUT',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLocaleService
   * @name UpdateLocaleActivation
   * @summary Update Locale Activation Status
   * @request PUT:/v1/admin/locales/{localeId}/activation
   * @secure
   */
  updateLocaleActivation = (
    localeId: number,
    data: AdminActivationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/locales/${localeId}/activation`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLocaleService
   * @name GetLocales1
   * @request GET:/v1/admin/locales
   * @secure
   */
  getLocales1 = (
    query?: {
      searchKeyword?: string;
      isActive?: boolean;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminSystemLocaleDto[], any>({
      path: `/v1/admin/locales`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLocaleService
   * @name CreateLocale
   * @summary Create System Locale
   * @request POST:/v1/admin/locales
   * @secure
   */
  createLocale = (data: AdminSystemLocaleDto, params: RequestParams = {}) =>
    this.http.request<AdminSystemLocaleDto, any>({
      path: `/v1/admin/locales`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
